import { useState } from 'react';
import { useAuth } from '../lib/AuthContext';

export default function Login() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(''); setBusy(true);
    const { error } = await signIn(email, password);
    if (error) setError(error.message);
    setBusy(false);
  };

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={onSubmit}>
        <h2>HUFT Retention</h2>
        <p className="tag">Sign in with your work email.</p>
        <label>Email</label>
        <input type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
        <label>Password</label>
        <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
        <button type="submit" className="submit" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
        {error && <div className="error">{error}</div>}
      </form>
    </div>
  );
}
